module.exports = __webpack_public_path__ + "media/images/site/CMEDIO_NOVO_ENSINO_MEDIO-473816514285b2db4c049fa1c249201a.jpg";